import { render, staticRenderFns } from "./upData.vue?vue&type=template&id=15220170&scoped=true&"
import script from "./upData.vue?vue&type=script&lang=js&"
export * from "./upData.vue?vue&type=script&lang=js&"
import style0 from "./upData.vue?vue&type=style&index=0&id=15220170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15220170",
  null
  
)

export default component.exports